import { render, staticRenderFns } from "./tableChargeGobal.vue?vue&type=template&id=4f04761a&scoped=true"
import script from "./tableChargeGobal.vue?vue&type=script&lang=js"
export * from "./tableChargeGobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f04761a",
  null
  
)

export default component.exports